import React, { FunctionComponent } from 'react';
import { decode } from 'html-entities';
import { DashboardTile } from './dashboard-tile';
import './styles/bulk_management.scss';

export interface Tile {
  href: string;
  icon: string;
  id: string;
  title: string;
  description: string;
  is_enabled: boolean; // eslint-disable-line @typescript-eslint/naming-convention
}

interface DashboardProps {
  links: Tile[];
}

export const Dashboard: FunctionComponent<DashboardProps> = (props) => {
  const { links } = props;
  return (
    <div className='manage-bulk-management' id='bulk-management-dashboard'>
      <h2>{`${decode(BFG.resource.name)} ${bfTranslate('Bulk Management')}`}</h2>
      <section className='bulk-management-tiles-container'>
        {links.map((link) => {
          if (link.href === 'dashboard') {
            return null;
          }
          return (
            <DashboardTile key={link.id} link={link} />
          );
        })}
      </section>
    </div>
  );
};
